import React from 'react';
import styled, { keyframes } from 'styled-components';

import Image from '../Image/Image';

import { GOTHAM_BOLD } from '../../styles/typography';
import { mediaMax } from '../../styles/sizes';

import Container from '../Container/Container';
import { FadeIn } from '../Animations/FadeIn';

const StyledHero = styled.div`
  width: 100%;
  height: 800px;
  left: 0;
  top: 0;
  position: relative;
  overflow: hidden;
  ${mediaMax.tablet`
    height: 600px;
  `}
  ${mediaMax.phone`
    height: 450px;
  `}
`;

const ZoomIn = keyframes`
      0% {
        transform: scale(1);
      }
      70% {
        transform: scale(1.3);
      }
      100% {
        transform: scale(1);
      }
`;

const StyledImg = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  z-index: -1;
  img {
    animation: ${ZoomIn} 30s ease-in-out 1;
  }
`;

const StyledHeroContent = styled.div`
  max-width: 450px;
`;

export const HeroTitle = styled.h1`
  font-size: 70px;
  font-family: ${GOTHAM_BOLD};
  color: #ffffff;
  text-transform: uppercase;
  line-height: 0.9;
  margin-bottom: 10px;
  padding-top: 176px;
  ${mediaMax.phone`
    font-size: 48px;
  `}
`;

export const HeroSubtitle = styled.h2`
  font-size: 24px;
  color: #ffffff;
  ${mediaMax.phone`
    font-size: 18px;
  `}
`;

const Hero = ({ children }) => {
  return (
    <StyledHero>
      <FadeIn>
        <StyledImg>
          <Image alt="Lion" src={'homepage-hero.jpg'} />
        </StyledImg>
      </FadeIn>
      <Container>
        <StyledHeroContent>{children}</StyledHeroContent>
      </Container>
    </StyledHero>
  );
};

export default Hero;
